export const CheckAdminRole = (role) => {
  const ADMIN_ROLES = [
    'manager',
    'super_admin',
    'admin',
    'mail_admin'
  ];

  const CUSTOMER_ROLES = [
    'subscriber'
  ];

  if (ADMIN_ROLES.includes(role))
    return true;

  return false;
}

export const GetRole = (acc) => {
  if (acc.is_manager)
    return 'manager';

  if (acc.is_super_admin)
    return 'super_admin';

  if (acc.is_admin)
    return 'admin';

  if (acc.is_mail_admin)
    return 'mail_admin';

  return 'subscriber';
}

export const CheckPrivileged = (acc) => {
  let role = GetRole(acc);

  return CheckAdminRole(role);
}

export const CheckHigherRole = (role1, role2) => {
  const ROLES_ORDER = [
    'manager',
    'super_admin',
    'admin',
    'mail_admin',
    'subscriber'
  ]

  let index1 = ROLES_ORDER.findIndex(item => item == role1);
  let index2 = ROLES_ORDER.findIndex(item => item == role2);

  if (index1 < 0 || index2 < 0)
    return false;
  
  if (index1 < index2)
    return true;

  return false;
}

export const CheckIsStaffDemo = (id) => {
  const ids = [368, 403, 845, 848, 962, 1074, 1075, 1181, 1183, 1184, 1185, 1190, 1191]
  return ids.includes(id);
}